import Card from '../../../components/common/Card/Card'

/**
 * PolicySection Component
 * Display individual leave policy section
 *
 * @param {string} title - Section title
 * @param {string} icon - FontAwesome icon class
 * @param {string} content - Policy content (markdown-formatted)
 */
const PolicySection = ({ title, icon, content }) => {
  return (
    <Card>
      {/* Section Header */}
      <div style={{
        marginBottom: '1rem',
        paddingBottom: '0.75rem',
        borderBottom: '2px solid var(--psyber-card-border)',
        display: 'flex',
        alignItems: 'center',
        gap: '0.75rem'
      }}>
        <div style={{
          width: '48px',
          height: '48px',
          borderRadius: 'var(--psyber-radius-md)',
          background: 'linear-gradient(135deg, var(--psyber-primary) 0%, var(--psyber-accent) 100%)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: 'var(--psyber-text-light)',
          fontSize: '1.5rem',
          flexShrink: 0
        }}>
          <i className={icon}></i>
        </div>
        <h3 style={{
          margin: 0,
          fontSize: 'var(--psyber-font-size-xl)',
          color: 'var(--psyber-text)',
          fontWeight: 700
        }}>
          {title}
        </h3>
      </div>

      {/* Section Content */}
      <div style={{
        color: 'var(--psyber-text-secondary)',
        fontSize: 'var(--psyber-font-size-base)',
        lineHeight: 1.8,
        whiteSpace: 'pre-wrap',
        wordBreak: 'break-word'
      }}>
        {content}
      </div>
    </Card>
  )
}

export default PolicySection
